// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

export const transactionAPI = {
  // GET /api/budget/transactions/?year=&month=&day=
  list: ({ year, month, day, ...rest } = {}) => {
    const params = new URLSearchParams();
    if (year && year !== 0) params.set('year', year);
    if (month && month !== 0) params.set('month', month);
    if (day && day !== 0) params.set('day', day);
    Object.entries(rest).forEach(([k, v]) => v != null && params.set(k, v));
    return api.get(`/api/budget/transactions/?${params.toString()}`);
  },

  // POST /api/budget/transactions/
  create: (transaction) => api.post('/api/budget/transactions/', transaction),

  // PUT /api/budget/transactions/:id/
  update: (id, transaction) =>
    api.put(`/api/budget/transactions/${id}/`, transaction),

  // PATCH /api/budget/transactions/:id/
  patch: (id, data) => api.patch(`/api/budget/transactions/${id}/`, data),

  // DELETE /api/budget/transactions/:id/
  delete: (id) => api.delete(`/api/budget/transactions/${id}/`),

  // POST /api/budget/transactions/bulk_update/ — group by type/category or
  // description (keyword/regex), preview with dry_run, then apply.
  bulkUpdate: (spec) =>
    api.post('/api/budget/transactions/bulk_update/', spec),

  // GET /api/budget/transactions/export/?<same filters as list()> (#32)
  // responseType 'blob': this is a CSV file, not JSON.
  export: (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v != null && v !== '' && query.set(k, v));
    return api.get(`/api/budget/transactions/export/?${query.toString()}`, {
      responseType: 'blob',
    });
  },

  // POST /api/budget/transactions/import-edits/ — multipart file upload.
  // Strictly update-only (#32): never creates a transaction, only edits
  // existing ones matched by the `id` column from a previous export().
  importEdits: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/budget/transactions/import-edits/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // ── Transfers (#31) — a full double-entry OUT+IN leg pair, managed as
  // a unit rather than through create()/update()/delete() above. ───────
  // POST /api/budget/transactions/transfer/
  createTransfer: (data) => api.post('/api/budget/transactions/transfer/', data),

  // GET /api/budget/transactions/transfer/<transfer_group>/
  getTransfer: (transferGroup) =>
    api.get(`/api/budget/transactions/transfer/${transferGroup}/`),

  // PATCH /api/budget/transactions/transfer/<transfer_group>/
  updateTransfer: (transferGroup, data) =>
    api.patch(`/api/budget/transactions/transfer/${transferGroup}/`, data),

  // DELETE /api/budget/transactions/transfer/<transfer_group>/
  deleteTransfer: (transferGroup) =>
    api.delete(`/api/budget/transactions/transfer/${transferGroup}/`),
};

export default transactionAPI;
